import { Injectable } from '@angular/core';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { IContributions } from 'src/app/shared/interfaces/contributions.interface';
import { IRentability } from 'src/app/shared/interfaces/rentability.interface';
import { IUserData } from 'src/app/shared/interfaces/user.interface';
import { IVoucherEmployerData } from 'src/app/shared/interfaces/stop.subscription.interface';

@Injectable({ providedIn: 'root' })
export class GlobalStorage {
  private _token: string = '';
  rentability: IRentability[] = [];
  activeSubscriptions: ICurrentSubscription[] = [];
  contributions: IContributions[] = [];

  userData: IUserData = {
    name: '',
    lastName: '',
    rut: '',
    email: '',
  };

  stopSubscriptionDocumentNumber = '';
  stopSubscriptionEmployerData: IVoucherEmployerData = {
    business: '',
    rut: '',
    email: '',
    pdf: {},
  };

  constructor() {
    // Recuperar token del sessionStorage al inicializar
    this._token = sessionStorage.getItem('auth_token') || '';
  }

  get token(): string {
    return this._token;
  }

  set token(value: string) {
    this._token = value;
    if (value) {
      sessionStorage.setItem('auth_token', value);
    } else {
      sessionStorage.removeItem('auth_token');
    }
  }
}